/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/416-twitch': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M1.5 0L0 2.5V14h4v2h2l2-2h2.5L15 9.5V0H1.5zM13 8.5L10.5 11H8l-2 2v-2H3V2h10v6.5z"/><path pid="1" d="M9.5 4H11v4H9.5V4zM6.5 4H8v4H6.5V4z"/>'
  }
})
